import { createFileRoute } from '@tanstack/react-router';
import { CapabilityTier } from '@signalvote/shared';
import { requireCapability } from '@/lib/routeGuards';
import { parseBookFilters } from '@/lib/fundraising/bookFilters';
import { ProspectDetail } from '@/components/fundraising';

// One Prospect's page. The book's filters ride along in the search, so the back link and J / K keep them.
// Fundraising:Manage, like the book.
export const Route = createFileRoute('/admin/fundraising/prospects/$prospectId')({
  validateSearch: parseBookFilters,
  beforeLoad: ({ context, params }) => {
    requireCapability(context, 'Fundraising', CapabilityTier.Manage, `/admin/fundraising/prospects/${params.prospectId}`);
  },
  component: ProspectRoute,
});

function ProspectRoute() {
  const { prospectId } = Route.useParams();
  const filters = Route.useSearch();
  return <ProspectDetail prospectId={prospectId} filters={filters} />;
}
